import React from 'react';

import { StageBadge } from './StageBadge';

interface RequestStageOrFailedBadgeProps {
  requestId: string;
  stage: string | undefined;
  size?: 'small' | 'medium' | 'large';
  enabled?: boolean; // Allow parent to control when to fetch
  /** Internal-only "Configuration" label (PRD FR7). Supplied by the screen; see StageBadge. */
  showInternalDetail?: boolean;
}

/**
 * Component that shows the StageBadge.
 * Note: Failed transcription jobs are now indicated with a separate FailedIndicator
 * component shown next to the request ID, not by replacing the stage badge.
 */
export const RequestStageOrFailedBadge: React.FC<
  RequestStageOrFailedBadgeProps
> = ({
  requestId,
  stage,
  size = 'small',
  enabled = true,
  showInternalDetail = false,
}) => {
  // Always show the normal stage badge
  return (
    <StageBadge
      stage={stage}
      size={size}
      showInternalDetail={showInternalDetail}
    />
  );
};
